var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgSireDistanceStrikeRate(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M13.54 9.78V5H20v1.43h-5.02v8.14H20V16h-6.46v-4.8H7.88V9.78zM.03 6.72a17.89 17.89 0 012.5-.16c1.5 0 2.46.25 3.24.78.87.6 1.43 1.58 1.43 3.03 0 1.6-.6 2.64-1.38 3.24-.87.68-2.15.98-3.7.98-1.02 0-1.7-.07-2.1-.14V6.72h.01zm2.1 6.2c.1.02.3.02.44.02 1.37.02 2.38-.74 2.38-2.52 0-1.53-.9-2.26-2.18-2.26-.34 0-.54.02-.64.05v4.7z",
    fill: "#010101"
  })));
}
export default SvgSireDistanceStrikeRate;